import styled from "@emotion/styled";
import Skeleton from "@mui/material/Skeleton";
import { ReactNode } from "react";

import AspectRatio from "~/components/common/AspectRatio";

import { NFT_IMAGE_ASPECT_RATIO_BY_VARIANT } from "./constants";
import { NftCardAspectRatioVariant } from "./declarations";
import {
  nftPageFeedCardDescriptionMarginMixin,
  NftPageFeedCardFooter,
  NftPageFeedCardFooterDivider,
  nftPageFeedCardTitleMarginMixin,
  NftPageFeedCardWrapper
} from "./styled";

type Props = {
  className?: string;
  children?: ReactNode;
  aspectRatioVariant?: NftCardAspectRatioVariant;
};

const NftContentCardSkeleton = ({
  children,
  className,
  aspectRatioVariant = NftCardAspectRatioVariant.square
}: Props): JSX.Element => (
  <NftPageFeedCardWrapper className={className}>
    <AspectRatio ratio={NFT_IMAGE_ASPECT_RATIO_BY_VARIANT[aspectRatioVariant]}>
      <Image />
    </AspectRatio>
    <Title />
    <Description />
    <NftPageFeedCardFooterDivider />
    <NftPageFeedCardFooter>{children}</NftPageFeedCardFooter>
  </NftPageFeedCardWrapper>
);

export default NftContentCardSkeleton;

const BaseSkeleton = styled(Skeleton)`
  border-radius: 8px;
`;
BaseSkeleton.defaultProps = {
  variant: "rectangular"
};

const Image = styled(BaseSkeleton)`
  border-radius: 24px;
  height: 100%;
  width: 100%;
`;

const Title = styled(BaseSkeleton)`
  ${nftPageFeedCardTitleMarginMixin}

  display: block;
  height: 24px;
  max-width: 100px;

  width: 100%;

  ${({ theme }) => theme.breakpoints.up("xs")} {
    height: 28px;
  }
`;

const Description = styled(BaseSkeleton)`
  ${nftPageFeedCardDescriptionMarginMixin}

  height: 120px;
`;
